import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Checkbox from '../../form/Checkbox'
import Select from '../../form/Select'

@observer
class GlobalSettingsModal extends PureComponent { // This is not a modal, but a left panel filter
    render() {
        const {
            benchmarkPeriodUpdater,
            benchmarkPeriods,
            presentationStore,
        } = this.props
        const { globalYears, globalBenchmarks } = presentationStore

        return (
            <div>
                {globalYears.length > 0 ? (
                    <fieldset className="filter">
                        <div className="filter-title">{i18n.t('presentation.globalSettings.comparisonYears')}</div>
                        <div className="filter-checkbox-group">
                            {globalYears.map((year) => (
                                <div key={year.value}>
                                    <Checkbox
                                        onBlur={presentationStore.globalYearSettingUpdater}
                                        label={`${year.label}`}
                                        name={year.value}
                                        checked={year.checked}
                                        className="exploriNativeCheckbox"
                                    />
                                </div>
                            ))}
                        </div>
                    </fieldset>
                ) : (null) }
                {globalBenchmarks.length > 0 ? (
                    <fieldset className="filter">
                        <div className="filter-title">{i18n.t('presentation.globalSettings.selectBenchmarks')}</div>
                        <div className="filter-checkbox-group">
                            {globalBenchmarks.map((benchmark) => (
                                <div key={benchmark.value}>
                                    <Checkbox
                                        onBlur={presentationStore.globalBenchmarkSettingUpdater}
                                        label={i18n.t(`report_${benchmark.value}_benchmark`)}
                                        name={benchmark.value}
                                        checked={benchmark.checked}
                                        className="exploriNativeCheckbox"
                                    />
                                </div>
                            ))}
                        </div>
                    </fieldset>
                ) : (null) }
                <fieldset className="filter">
                    <div className="filter-title">{i18n.t('presentation.globalSettings.benchmarkPeriod')}</div>
                    <Select
                        options={benchmarkPeriods}
                        value={benchmarkPeriods.find(({ value }) => value === presentationStore.benchmarkPeriod )}
                        onBlur={benchmarkPeriodUpdater}
                        name="benchmarkPeriod"
                    />
                </fieldset>
            </div>
        )
    }
}

GlobalSettingsModal.propTypes = {
    modalStatus: PropTypes.bool.isRequired,
    handleGlobalSettingsModal: PropTypes.func,
    globalYears: PropTypes.array,
    globalBenchmarks: PropTypes.array,
    globalSettingUpdater: PropTypes.func,
}

export default GlobalSettingsModal
